import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { JobColorEnum } from '../../enum';
import { CoreStatus } from '../CoreStatus';

interface JobColorProps {
  value: JobColorEnum;
}

const JobColorMapping = {
  [JobColorEnum.BLUE]: '#3B82F6',
  [JobColorEnum.YELLOW]: '#D19500',
  [JobColorEnum.RED]: '#DC2626',
  [JobColorEnum.GREEN]: '#22C55E',
  [JobColorEnum.BLACK]: '#0A0A0A',
  [JobColorEnum.PURPLE]: '#A855F7',
  [JobColorEnum.PINK]: '#EC4899',
  [JobColorEnum.ORANGE]: '#F97316',
  [JobColorEnum.BROWN]: '#996633',
  [JobColorEnum.LIGHT_BLUE]: '#41ECF5',
  [JobColorEnum.CYAN]: '#40EDF5',
  [JobColorEnum.WHITE]: '#FFFEFE',
  [JobColorEnum.GREY]: '#CDCDCC',
};
export const JobColor: FC<JobColorProps> = ({ value }) => {
  const { t } = useTranslation('status', { keyPrefix: 'jobColor' });

  return (
    <CoreStatus
      value={t(value, value)}
      backgroundColor={JobColorMapping[value]}
    />
  );
};
